var map = {
	"./bccsa/colours.js": 1589,
	"./cressey/colours.js": 1590,
	"./csam/colours.js": 1591,
	"./goldenacorn/colours.js": 1592,
	"./ibew/colours.js": 1593,
	"./orangepiggy/colours.js": 1594,
	"./wgplangrid/colours.js": 1595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1588;